import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class CurrencyQueryCriteriaClass extends BaseCriteriaModel {
  code?: Optional<string> = Optional.empty();
  display_long?: Optional<string> = Optional.empty();
  display_main?: Optional<string> = Optional.empty();
  display_medium?: Optional<string> = Optional.empty();
  display_short?: Optional<string> = Optional.empty();
}

export class CurrencyCriteriaModelQuery {
  query = '';

  constructor(currencyCriteriaModel: CurrencyQueryCriteriaClass) {

    if (!currencyCriteriaModel) {
      return;
    }

    this.query += currencyCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += currencyCriteriaModel.display_long.filter(x => x !== '').map(x => '&display_long=' + x).orElse('');
    this.query += currencyCriteriaModel.display_main.filter(x => x !== '').map(x => '&display_main=' + x).orElse('');
    this.query += currencyCriteriaModel.display_medium.filter(x => x !== '').map(x => '&display_medium=' + x).orElse('');
    this.query += currencyCriteriaModel.display_short.filter(x => x !== '').map(x => '&display_short=' + x).orElse('');

    this.query += '&status=' + currencyCriteriaModel.status;
    this.query += '&orderBy=' + currencyCriteriaModel.orderBy;
    this.query += '&order=' + currencyCriteriaModel.order;
    this.query += '&offset=' + currencyCriteriaModel.offset + '&limit=' + currencyCriteriaModel.limit;
  }
}
